import React, { Component } from 'react'
import { connect } from 'react-redux'
import Line from './../Line'
import DecimalInput from '../../DecimalInput'
import RPReportFiles from './../RPReportFiles'

import { translation } from '../../../../utils/helpers'

import './manualbody.scss'
import { hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'

// constants
import { AssessmentReporType } from '../../../../constants'

// Elements
import Button from '../../../elements/button'
import AssessmentReportSums from '../AssessmentReportSums'

class ManualBody extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
    this.onPriceFieldBlur = this.onPriceFieldBlur.bind(this)
  }

  componentDidMount () {
    if (!this.props.noRef) {
      this.props.onRef(this)
    }
  }

  componentWillUnmount () {
    if (!this.props.noRef) {
      this.props.onRef(undefined)
    }
  }

  getTitle () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(1396)
    }
    switch (this.props.order.OrderType) {
      case 1:
        return translation(13360)
      case 2:
        return translation(71)
      case 3:
        return translation(13361)
      case 6:
        return translation(785)
    }
    return 'No title'
  }

  getTitleAria () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(34) + ' ' + translation(1396)
    }
    return translation(2705)
  }

  getIcon () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return '/images/svgs/taksering/Additional-sales-new.svg'
    }
    switch (this.props.order.OrderType) {
      case 1:
        return '/images/svgs/ordrer/Insurance-black.svg'
      case 2:
        return '/images/svgs/ordrer/Salescar-black.svg'
      case 3:
        return '/images/svgs/ordrer/Garanteed-black.svg'
      case 6:
        return '/images/svgs/ordrer/Private_c-black.svg'
    }
    return null
  }

  getEditUrl () {
    if (this.props.department === 1) {
      return '/pricecalculation/' + this.props.order.Id + '/manualbody'
    }
  }

  onPriceFieldBlur (args) {
    if (this.props.order[args.name] !== undefined && this.props.order[args.name] !== args.value) {
      let data = { OrderID: this.props.order.Id }
      if (args.name.includes('ManualBody')) {
        data.BodyShopPrice = {
          [args.name]: args.value,
          IsDirty: true
        }
      } else {
        data.Other = {
          [args.name]: args.value,
          IsDirty: true
        }
      }
      console.log('onPriceFieldBlur -> saveOrder')
      this.props.saveOrder(data)
    }
  }

  renderRpReports () {
    if (!hasSubscriptionPermission(this.props.auth, 10) && !hasPartnerSubscriptionPermission(this.props.auth, 10)) return null
    let renderPaint = this.props.editable || this.props.department === 0
    let renderBody = this.props.editable || this.props.department === 1
    let renderSparePart = this.props.editable
    return <RPReportFiles
      order={this.props.order}
      editable={this.props.editable}
      renderPaint={renderPaint}
      renderBody={renderBody}
      renderSparePart={renderSparePart}
      onUploadSuccess={this.props.loadOrder.bind(this, true)}
      showDates={!this.props.editable}
      />
  }

  renderAmountField (field, label, value, bold = false, disabled = false) {
    if (value === null) value = 0
    // console.log('value ', value)
    let amount = value
    if (this.props.editable) {
      if (this.props.order.ReportType === AssessmentReporType.DBS) return // use to hide manual body price
      amount = () => {
        return (
          <div className='amount'>
            <DecimalInput size='s' name={field} value={value} onBlur={this.onPriceFieldBlur} disabled={disabled} rightAlign />
          </div>
        )
      }
    }
    if (!this.props.order || !this.props.order.ShowPrices) return null
    return (
      <Line boldText text={label} amount={amount} bold={bold} currencyType={this.props.currencyCode} />
    )
  }

  renderAmounts () {
    const hasPaintPriceList = this.props.order.HasBasePaintPriceList
    const isCorrectViewMode = this.props.viewMode !== 'simple'
    // let hasBodyPriceList = true

    const renderDivider = (text) => {
      if (text !== undefined) {
        return (
          <div className='title spacing'>{text}</div>
        )
      }
      return (
        <div className='h-line bold' />
      )
    }

    const renderTotals = () => {
      return (
        <div className='totals'>
          {isCorrectViewMode && this.renderAmountField('ManualBodyGross', translation(13376), this.props.order.ManualBodyGross)}
          {isCorrectViewMode && this.renderAmountField('ManualBodyVat', translation(13390), this.props.order.ManualBodyVat)}
          {isCorrectViewMode && renderDivider()}
          {this.renderAmountField('ManualBodyTotal', translation(393), this.props.order.ManualBodyTotal, true)}
        </div>
      )
    }

    return (
      <div>
        {isCorrectViewMode && this.renderAmountField('ManualBodyWorkPrice', translation(416), this.props.order.ManualBodyWorkPrice)}
        {isCorrectViewMode && this.renderAmountField('ManualBodySparePartPrice', translation(637), this.props.order.ManualBodySparePartPrice)}
        {isCorrectViewMode && this.renderAmountField('ManualBodyMiscPrice', translation(15154), this.props.order.ManualBodyMiscPrice)}
        {isCorrectViewMode && !hasPaintPriceList && this.props.editable && this.renderAmountField('Price', translation(660), this.props.order.Price, false, !this.props.order.IsDraft)}
        {isCorrectViewMode && !hasPaintPriceList && this.props.editable && this.renderAmountField('Environment', translation(15155), this.props.order.Environment, false, !this.props.order.IsDraft)}
        {isCorrectViewMode && this.renderAmountField('ManualBodyWorkEnvPrice', translation(15156), this.props.order.ManualBodyWorkEnvPrice)}
        {!this.props.editable && renderTotals()}
      </div>
    )
  }

  renderInnerTitle () {
    let title = this.props.editable ? translation(1913) : '' // translation(889)
    if (this.props.overrideInnerTitle !== null) {
      title = this.props.overrideInnerTitle
    }

    if (!title) return null

    return (
      <div className='h-line title'>{title}</div>
    )
  }

  renderReportSums () {
    let sumDepartment = this.props.department
    if (this.props.department === 1 && [1, 3].includes(this.props.extentInfo.PaintBase)) { // If body department and use paint report...
      sumDepartment = 2   // ...render both body and paint
    }
    return (
      <div>
        <AssessmentReportSums report={this.props.order.Report} department={sumDepartment} currencyCode={this.props.currencyCode} includeTotal={false} />
      </div>
    )
  }

  render () {
    let css = 'manualbody' + (this.props.editable ? ' editable' : '')
    return (
      <div className={css}>
        {this.props.viewMode === 'mobile' && this.props.renderInside()}
        <form onSubmit={(e) => { e.preventDefault() }}>
          {!this.props.hideTitle && this.renderInnerTitle()}
          {!this.props.hideFile && !this.props.editable && this.renderRpReports()}
          {!this.props.order.Report && this.renderAmounts() || this.renderReportSums()}
          {this.props.editable && this.renderRpReports()}
        </form>
        {this.props.editable && <Button onClick={this.props.goBack} labelText={translation('956')} />}
      </div>
    )
  }
}

ManualBody.contextTypes = {
  // router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {

})(ManualBody)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/ManualBody/index.js